import React, {useState,useEffect} from "react"
import { getDatabase, ref, onValue } from "firebase/database"
import { getDownloadURL,ref as reff, getStorage} from "firebase/storage"
import app from "../../api/firebaseConf"
import moment from "moment"
import { Chart } from "react-chartjs-2"

export default function Grafic (props){
    const [dates, setDates] = useState([])
    const [datos, setDatos] = useState([])
    const [img,setImg]  = useState('')

    useEffect(()=>{
      const db = getDatabase(app);
      const storage = getStorage(app)
        
        const starCountRef = ref(db, props.path);
        onValue(starCountRef, async(snapshot) => {
        //const data = snapshot.val();
        //console.log(data)

        const dataDates = [];
        const dataTemp = [];
        //const array = []

        snapshot.forEach((data) => {
            const dataVal = data.val();
            
            const fecha = moment.unix(dataVal.epoch).format('h:mm:ss');
            //const temperatura = data.val().temp
            dataDates.push(fecha);
            dataTemp.push(data.val().reading)
            //array.push({fecha: fecha, temperatura: temperatura})
            
        })
        //console.log(dataTemp)
        //console.log(dataDates)
        let lastdata = 7
        if (props.tipo !== 'line'){
            lastdata = 1
        }
        const imagen = async(filename) =>{
          const  fileref = reff(storage,`${filename}.png`)
          const urldownload = await getDownloadURL(fileref)
          setImg(urldownload)
        }
        while (dataDates.length > lastdata)
            {
                dataDates.shift()
                dataTemp.shift()
            }

            setDatos(dataTemp)
            setDates(dataDates)
            //console.log(dataTemp)
            if (props.tipo === 'on/off'){
              let seleccion = ''
              if (props.tiposw === 'puerta'){
                seleccion = 'door'
              }else{
                seleccion = 'window'
              }

              if(dataTemp[0] === 'open'){
                imagen(`${seleccion}_open`)
              }else{
                imagen(`${seleccion}_close`)
              }
            }
    });

    },[])
    
    //console.log(datos)
    let firedata = undefined
    let options = undefined

    if (props.tipo === 'line'){
     firedata = {
        labels: dates ? [...dates] : null,
        datasets: [{
          label: props.label,
          data: datos ? [...datos] : null,
          backgroundColor: [props.color+'40'],
          pointBackgroundColor: props.color,
          pointBorderColor: props.color,
          borderColor: props.color,
          borderWidth: 2,
          fill: true,
          tension: 0.3
  
      }]
      }
        options = {
        plugins: {
          legend: {
            labels: {
                font: {
                    size: 16,
                    weight: "bold"
                }
            }
        },
        scales: { 
          y: {
            min: 0,
            max: props.max ? props.max : 80,
          }
        }
      }
    
    }}
    else if (props.tipo === 'doughnut'){

        firedata = {
            labels: [props.label],
              datasets: [{
                label: 'My First Dataset',
                data: [datos[0],80 - datos[0]],
                backgroundColor: [
                  props.color,
                  '#D5D5D5',
                ],
                hoverOffset: 4,
              }],
            };

            options = {
                circumference: 180,
                rotation: 270,
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                  legend: {
                      labels: {
                          font: {
                              size: 16,
                              weight: "bold"
                          },

                      }
                  }
              }
              

              }

    }

    if (props.tipo === 'on/off'){
      return  <div>
                <p className='flex items-center justify-center font-press-start font-semibold capitalize text-sm sm:text-xl text-slate-600 py-1'>{props.label}</p>
                <img src={img} className='flex items-center justify-center'/>
              </div>
    }
    else {
    return (
        <div>
            {<Chart type={props.tipo} data={firedata} options = {options}/>}
        </div>)
    }
}